const organizations = {
    title: 'Organizace',
    description: 'Vytvářejte a spravujte organizace, do kterých patříte.',
    create: 'Vytvořit organizaci',
    create_title: 'Vytvořit novou organizaci',
    name: 'Název organizace',
    avatar: 'Avatar organizace',
    avatar_removed: 'Avatar organizace byl odebrán.',
    description_label: 'Popis',
    empty: 'Zatím nejste členem žádné organizace.',
    pending_invitations: 'Čekající pozvánky',
    accept: 'Přijmout',
    decline: 'Odmítnout',
    owner: 'Vlastník',
    tabs: {
        overview: 'Přehled',
        members: 'Členové',
        invitations: 'Pozvánky',
        roles: 'Role správy',
        branding: 'Vzhled značky',
        security: 'Zabezpečení',
        jit: 'Zřizování JIT',
        applications: 'Sdílené prostředky',
        activity: 'Aktivita',
        deletion: 'Odstranit',
    },
    members: {
        title: 'Členové',
        empty: 'Nebyli nalezeni žádní členové.',
        remove: 'Odebrat',
        removed: 'Člen byl odebrán.',
        business_roles: 'Obchodní role',
        no_business_roles: 'Nejsou dostupné žádné obchodní role. Požádejte správce tenanta o sdílení rolí s touto organizací.',
    },
    invitations: {
        title: 'Pozvánky',
        invite: 'Pozvat člena',
        email: 'E-mailová adresa',
        empty: 'Nebyly nalezeny žádné pozvánky.',
        resend: 'Odeslat znovu',
        resent: 'Pozvánka byla odeslána znovu.',
        revoke: 'Odvolat',
        revoked: 'Pozvánka byla odvolána.',
        status: {
            Pending: 'Čekající',
            Accepted: 'Přijata',
            Expired: 'Platnost vypršela',
            Revoked: 'Odvolána',
            Declined: 'Odmítnuta',
        },
    },
    roles: {
        title: 'Role správy',
        create: 'Vytvořit roli',
        permissions: 'Oprávnění',
        empty: 'Nebyly nalezeny žádné role správy.',
        select_member: 'Vybrat člena',
        select_role: 'Vybrat roli',
        assign: 'Přiřadit roli',
        assigned: 'Role byla přiřazena.',
        unassign: 'Odebrat roli',
        unassigned: 'Role byla odebrána.',
        permission_count: 'Oprávnění: {{count}}',
        built_in: {
            owner: 'Vlastník',
            owner_description: 'Vlastníci mají výhradní práva ke správě vlastnictví a odstranění organizace.',
            administrator: 'Správce',
            administrator_description: 'Spravuje organizaci kromě akcí vyhrazených vlastníkům.',
        },
        permission_labels: {
            update_profile: 'Upravit profil',
            manage_branding: 'Spravovat vzhled značky',
            view_members: 'Zobrazit členy',
            manage_members: 'Spravovat členy',
            manage_invitations: 'Spravovat pozvánky',
            assign_business_roles: 'Přiřazovat obchodní role',
            manage_management_roles: 'Spravovat role správy',
            assign_management_roles: 'Přiřazovat role správy',
            manage_security: 'Spravovat zabezpečení',
            manage_jit: 'Spravovat zřizování JIT',
            manage_applications: 'Spravovat aplikace',
            view_activity: 'Zobrazit aktivitu',
        },
    },
    branding: {
        title: 'Vzhled značky organizace',
        primary_color: 'Hlavní barva',
        custom_css: 'Vlastní CSS',
        preview: 'Náhled',
        light: 'Světlý',
        dark: 'Tmavý',
    },
    security: {
        title: 'Zabezpečení organizace',
        require_mfa: 'Vyžadovat vícefaktorové ověření členů',
    },
    jit: {
        title: 'E-mailové domény JIT',
        domain: 'E-mailová doména',
        add: 'Přidat doménu',
        verify: 'Ověřit DNS',
        dns_instruction: 'Vytvořte záznam TXT {{record}} s hodnotou {{value}}.',
        verified: 'Ověřeno',
    },
    applications: {
        title: 'Sdílené prostředky',
        empty: 'Pro tuto organizaci nejsou dostupné žádné prostředky.',
        sso: 'Podniková připojení SSO',
        m2m: 'Aplikace mezi stroji',
    },
    activity: {
        title: 'Aktivita organizace',
        empty: 'Zatím žádná aktivita.',
        events: {
            create: 'Organizace vytvořena',
            delete: 'Organizace odstraněna',
            profile: 'Profil organizace aktualizován',
            branding: 'Vzhled značky aktualizován',
            security: 'Zabezpečení organizace aktualizováno',
            member_add: 'Člen přidán',
            member_remove: 'Člen odebrán',
            owner: 'Vlastnictví organizace změněno',
            role_create: 'Role správy vytvořena',
            role_update: 'Role správy aktualizována',
            role_delete: 'Role správy odstraněna',
            role_assign: 'Role správy přiřazena',
            role_unassign: 'Role správy odebrána členovi',
            business_role: 'Obchodní role aktualizovány',
            invitation_create: 'Pozvánka odeslána',
            invitation_accept: 'Pozvánka přijata',
            invitation_decline: 'Pozvánka odmítnuta',
            invitation_revoke: 'Pozvánka odvolána',
            jit: 'Zřizování JIT aktualizováno',
            domain: 'Ověření e-mailové domény',
            application: 'Připojení aplikací aktualizována',
            unknown: 'Aktivita organizace',
        },
    },
    save: 'Uložit změny',
    cancel: 'Zrušit',
    delete: 'Odstranit organizaci',
    delete_confirmation: 'Tímto trvale odstraníte organizaci a její členství. Pro potvrzení zadejte „{{name}}“.',
    deleted: 'Organizace byla odstraněna.',
    load_failed: 'Data organizace se nepodařilo načíst. Zkuste to znovu.',
    permission_denied: 'Nemáte oprávnění zobrazit tuto sekci.',
};
export default organizations;
